import React, { useContext } from 'react'
import { Link, navigate } from 'gatsby'
import { FaBars } from 'react-icons/fa'
import logo from '../assets/fe_icon.png'
import logo2 from '../assets/fe_icon2.png'
import styled from 'styled-components'

import Links from '../constants/links'
import SocialLinks from '../constants/socialLinks'

const Navbar = ({ toggle }) => {
  return (
    <Wrapper>
      <nav className="navbar">
        <a
          href="https://feplayground.typeform.com/to/WFImztL8"
          target="_blank"
          className="betabar"
        ></a>
        <div className="nav-center">
          <div className="nav-header">
            <Link to="/" className="nav-logo">
              {/* <img src={logo} alt="mdx logo" />Frontend Playground */}
              <div className="logo" style={{ fontSize: '32px' }}>
                <img src={logo} />
              </div>
            </Link>
            <button className="toggle-btn" onClick={toggle}>
              <FaBars />
            </button>
          </div>
          <Links styleClass="nav-links" toggle={toggle} />
          {/* <SocialLinks styleClass="nav-icons" /> */}
        </div>
      </nav>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .betabar:after {
    content: 'beta';
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    height: 25px;
    background: #5c2c8f;
    top: 7px;
    left: -20px;
    text-align: center;
    font-size: 13px;
    font-family: sans-serif;
    text-transform: uppercase;
    font-weight: bold;
    color: #fff;
    line-height: 27px;
    transform: rotate(-45deg);
  }
`

export default Navbar
